import React, { useContext } from 'react'
import { DataInstructionContext } from '../types'
import { InputElement } from '../../../HtmlComponents/InputElement'
import { useTranslation } from 'react-i18next'

const InputsInstructions = () => {
  const {
    contentFr, setContentFr,
    contentAr, setContentAr,
  } = useContext(DataInstructionContext)

  const { t } = useTranslation()

  return (
    <>
      <InputElement name={t("Contenu Fr")} placeholder={t("Donner le contenu en francais")} value={contentFr} setValue={setContentFr}/>
      <InputElement name={t("Contenu Ar")} placeholder={t("Donner le contenu en arabe")} value={contentAr} setValue={setContentAr}/>
    </>
  )
}

export default InputsInstructions